import * as React from "react";

function CloseIcon(props) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.60938 0.890625L0.890625 1.60938L5.28125 6L0.890625 10.3906L1.60938 11.1094L6 6.71875L10.3906 11.1094L11.1094 10.3906L6.71875 6L11.1094 1.60938L10.3906 0.890625L6 5.28125L1.60938 0.890625Z"
        fill="#778CA2"
        {...props}
      />
    </svg>
  );
}

function MoreIcon() {
  return (
    <svg
      width="12"
      height="3"
      viewBox="0 0 12 3"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 0.181641C0.71875 0.181641 0.479167 0.280599 0.28125 0.478516C0.09375 0.666016 0 0.900391 0 1.18164C0 1.46289 0.09375 1.70247 0.28125 1.90039C0.479167 2.08789 0.71875 2.18164 1 2.18164C1.28125 2.18164 1.51562 2.08789 1.70312 1.90039C1.90104 1.70247 2 1.46289 2 1.18164C2 0.900391 1.90104 0.666016 1.70312 0.478516C1.51562 0.280599 1.28125 0.181641 1 0.181641ZM6 0.181641C5.71875 0.181641 5.47917 0.280599 5.28125 0.478516C5.09375 0.666016 5 0.900391 5 1.18164C5 1.46289 5.09375 1.70247 5.28125 1.90039C5.47917 2.08789 5.71875 2.18164 6 2.18164C6.28125 2.18164 6.51562 2.08789 6.70312 1.90039C6.90104 1.70247 7 1.46289 7 1.18164C7 0.900391 6.90104 0.666016 6.70312 0.478516C6.51562 0.280599 6.28125 0.181641 6 0.181641ZM11 0.181641C10.7188 0.181641 10.4792 0.280599 10.2812 0.478516C10.0938 0.666016 10 0.900391 10 1.18164C10 1.46289 10.0938 1.70247 10.2812 1.90039C10.4792 2.08789 10.7188 2.18164 11 2.18164C11.2812 2.18164 11.5156 2.08789 11.7031 1.90039C11.901 1.70247 12 1.46289 12 1.18164C12 0.900391 11.901 0.666016 11.7031 0.478516C11.5156 0.280599 11.2812 0.181641 11 0.181641Z"
        fill="#98A9BC"
      />
    </svg>
  );
}

function EditIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0625 0.517578C11.6055 0.517578 11.2129 0.681641 10.8848 1.00977L5.18945 6.6875L4.76758 8.83203L4.5918 9.6582L5.41797 9.48242L7.5625 9.06055L13.2402 3.36523C13.5684 3.03711 13.7324 2.64453 13.7324 2.1875C13.7324 1.73047 13.5684 1.33789 13.2402 1.00977C12.9121 0.681641 12.5195 0.517578 12.0625 0.517578ZM12.0625 1.60742C12.1914 1.60742 12.3203 1.67187 12.4492 1.80078C12.5781 1.92969 12.6426 2.05859 12.6426 2.1875C12.6426 2.31641 12.5781 2.44531 12.4492 2.57422L7 8.02344L6.0332 8.2168L6.22656 7.25L11.6758 1.80078C11.8047 1.67187 11.9336 1.60742 12.0625 1.60742ZM0.25 2.75V14H11.5V6.58203L10.375 7.70703V12.875H1.375V3.875H6.54297L7.66797 2.75H0.25Z"
        fill="#778CA2"
      />
    </svg>
  );
}

function DeleteIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.875 0.5C5.54688 0.5 5.27734 0.605469 5.06641 0.816406C4.85547 1.02734 4.75 1.29688 4.75 1.625V2.1875H0.8125V3.3125H1.42773L2.55273 14H11.4473L12.5723 3.3125H13.1875V2.1875H9.25V1.625C9.25 1.29688 9.14453 1.02734 8.93359 0.816406C8.72266 0.605469 8.45312 0.5 8.125 0.5H5.875ZM5.875 1.625H8.125V2.1875H5.875V1.625ZM2.57031 3.3125H11.4297L10.4277 12.875H3.57227L2.57031 3.3125ZM4.75 5V11.1875H5.875V5H4.75ZM6.4375 5V11.1875H7.5625V5H6.4375ZM8.125 5V11.1875H9.25V5H8.125Z"
        fill="#778CA2"
      />
    </svg>
  );
}

function PrevIcon() {
  return (
    <svg
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.68262 0.658203L0.495117 6.8457L0.108398 7.25L0.495117 7.6543L6.68262 13.8418L7.49121 13.0332L1.70801 7.25L7.49121 1.4668L6.68262 0.658203Z"
        fill="#778CA2"
      />
    </svg>
  );
}

function NextIcon() {
  return (
    <svg
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.12842 13.3418L0.319824 12.5332L6.10303 6.75L0.319824 0.966797L1.12842 0.158203L7.31592 6.3457L7.70264 6.75L7.31592 7.1543L1.12842 13.3418Z"
        fill="#778CA2"
      />
    </svg>
  );
}

function RingIcon() {
  return (
    <svg
      width="15"
      height="19"
      viewBox="0 0 15 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.32422 1.24219C6.61068 0.955729 6.9401 0.8125 7.3125 0.8125C7.6849 0.8125 8 0.955729 8.25781 1.24219C8.54427 1.5 8.6875 1.8151 8.6875 2.1875C8.6875 2.1875 8.6875 2.24479 8.6875 2.35938C9.89062 2.67448 10.8789 3.34766 11.6523 4.37891C12.4258 5.41016 12.8125 6.57031 12.8125 7.85938V13.875C12.8125 14.3333 13.0417 14.5625 13.5 14.5625H14.1875V15.9375H9.24609C9.33203 16.1667 9.375 16.3958 9.375 16.625C9.375 17.1979 9.17448 17.6849 8.77344 18.0859C8.3724 18.487 7.88542 18.6875 7.3125 18.6875C6.73958 18.6875 6.2526 18.487 5.85156 18.0859C5.45052 17.6849 5.25 17.1979 5.25 16.625C5.25 16.3958 5.29297 16.1667 5.37891 15.9375H0.4375V14.5625H1.125C1.58333 14.5625 1.8125 14.3333 1.8125 13.875V7.6875C1.8125 6.42708 2.19922 5.3099 2.97266 4.33594C3.77474 3.33333 4.76302 2.67448 5.9375 2.35938C5.9375 2.24479 5.9375 2.1875 5.9375 2.1875C5.9375 1.8151 6.06641 1.5 6.32422 1.24219ZM7.01172 3.5625C5.92318 3.64844 5.00651 4.09245 4.26172 4.89453C3.54557 5.66797 3.1875 6.59896 3.1875 7.6875V13.875C3.1875 14.1042 3.14453 14.3333 3.05859 14.5625H11.5664C11.4805 14.3333 11.4375 14.1042 11.4375 13.875V7.85938C11.4375 6.71354 11.0508 5.72526 10.2773 4.89453C9.50391 4.03516 8.55859 3.59115 7.44141 3.5625H7.3125H7.14062H7.01172ZM8 16.625C8 16.1667 7.77083 15.9375 7.3125 15.9375C6.85417 15.9375 6.625 16.1667 6.625 16.625C6.625 17.0833 6.85417 17.3125 7.3125 17.3125C7.77083 17.3125 8 17.0833 8 16.625Z"
        fill="#FAFBFF"
      />
    </svg>
  );
}

function AddContactIcon() {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.75 0.375C5.03516 0.375 4.37305 0.550781 3.76367 0.902344C3.16602 1.25391 2.69141 1.73438 2.33984 2.34375C1.98828 2.94141 1.8125 3.59766 1.8125 4.3125C1.8125 4.98047 1.96484 5.60156 2.26953 6.17578C2.58594 6.75 3.01367 7.21875 3.55273 7.58203C2.88477 7.875 2.28711 8.2793 1.75977 8.79492C1.24414 9.31055 0.845703 9.90234 0.564453 10.5703C0.271484 11.2617 0.125 11.9883 0.125 12.75H1.25C1.25 11.9297 1.44922 11.1797 1.84766 10.5C2.25781 9.80859 2.80273 9.26367 3.48242 8.86523C4.17383 8.45508 4.92969 8.25 5.75 8.25C6.5 8.25 7.20898 8.43164 7.87695 8.79492C7.56055 9.19336 7.31445 9.63281 7.13867 10.1133C6.96289 10.5938 6.875 11.0977 6.875 11.625C6.875 12.4336 7.07422 13.1836 7.47266 13.875C7.88281 14.5664 8.43359 15.1113 9.125 15.5098C9.81641 15.9199 10.5664 16.125 11.375 16.125C12.1836 16.125 12.9336 15.9199 13.625 15.5098C14.3164 15.1113 14.8613 14.5664 15.2598 13.875C15.6699 13.1836 15.875 12.4336 15.875 11.625C15.875 10.8164 15.6699 10.0664 15.2598 9.375C14.8613 8.68359 14.3164 8.13867 13.625 7.74023C12.9336 7.33008 12.1836 7.125 11.375 7.125C10.8945 7.125 10.4258 7.20117 9.96875 7.35352C9.52344 7.50586 9.11328 7.7168 8.73828 7.98633C8.51562 7.8457 8.25195 7.71094 7.94727 7.58203C8.48633 7.21875 8.9082 6.75 9.21289 6.17578C9.5293 5.60156 9.6875 4.98047 9.6875 4.3125C9.6875 3.59766 9.51172 2.94141 9.16016 2.34375C8.80859 1.73438 8.32812 1.25391 7.71875 0.902344C7.12109 0.550781 6.46484 0.375 5.75 0.375ZM5.75 1.5C6.26562 1.5 6.73438 1.62891 7.15625 1.88672C7.58984 2.13281 7.92969 2.47266 8.17578 2.90625C8.43359 3.32812 8.5625 3.79687 8.5625 4.3125C8.5625 4.82813 8.43359 5.30273 8.17578 5.73633C7.92969 6.1582 7.58984 6.49805 7.15625 6.75586C6.73438 7.00195 6.26562 7.125 5.75 7.125C5.23438 7.125 4.75977 7.00195 4.32617 6.75586C3.9043 6.49805 3.56445 6.1582 3.30664 5.73633C3.06055 5.30273 2.9375 4.82813 2.9375 4.3125C2.9375 3.79687 3.06055 3.32812 3.30664 2.90625C3.56445 2.47266 3.9043 2.13281 4.32617 1.88672C4.75977 1.62891 5.23438 1.5 5.75 1.5ZM11.375 8.25C11.9844 8.25 12.5469 8.40234 13.0625 8.70703C13.5781 9.01172 13.9883 9.42188 14.293 9.9375C14.5977 10.4531 14.75 11.0156 14.75 11.625C14.75 12.2344 14.5977 12.7969 14.293 13.3125C13.9883 13.8281 13.5781 14.2383 13.0625 14.543C12.5469 14.8477 11.9844 15 11.375 15C10.7656 15 10.2031 14.8477 9.6875 14.543C9.17188 14.2383 8.76172 13.8281 8.45703 13.3125C8.15234 12.7969 8 12.2344 8 11.625C8 11.0156 8.15234 10.4531 8.45703 9.9375C8.76172 9.42188 9.17188 9.01172 9.6875 8.70703C10.2031 8.40234 10.7656 8.25 11.375 8.25ZM10.8125 9.375V11.0625H9.125V12.1875H10.8125V13.875H11.9375V12.1875H13.625V11.0625H11.9375V9.375H10.8125Z"
        fill="#778CA2"
      />
    </svg>
  );
}

function SelectIcon() {
  return (
    <svg
      width="16"
      height="9"
      viewBox="0 0 16 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.39062 0.296875L8 6.94141L14.6094 0.296875L15.4531 1.14062L8.42188 8.17188L8 8.52344L7.57812 8.17188L0.546875 1.14062L1.39062 0.296875Z"
        fill="#778CA2"
      />
    </svg>
  );
}

function CloseRoundIcon(props) {
  return (
    <svg
      {...props}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1569 0.25C8.39126 0.25 6.75064 0.695312 5.23501 1.58594C3.76626 2.44531 2.6022 3.60938 1.74283 5.07812C0.852201 6.59375 0.406888 8.23438 0.406888 10C0.406888 11.7656 0.852201 13.4062 1.74283 14.9219C2.6022 16.3906 3.76626 17.5547 5.23501 18.4141C6.75064 19.3047 8.39126 19.75 10.1569 19.75C11.9225 19.75 13.5631 19.3047 15.0788 18.4141C16.5475 17.5547 17.7116 16.3906 18.571 14.9219C19.4616 13.4062 19.9069 11.7656 19.9069 10C19.9069 8.23438 19.4616 6.59375 18.571 5.07812C17.7116 3.60938 16.5475 2.44531 15.0788 1.58594C13.5631 0.695312 11.9225 0.25 10.1569 0.25ZM10.1569 1.75C11.6569 1.75 13.0475 2.125 14.3288 2.875C15.5631 3.60938 16.5475 4.59375 17.2819 5.82812C18.0319 7.10938 18.4069 8.5 18.4069 10C18.4069 11.5 18.0319 12.8906 17.2819 14.1719C16.5475 15.4062 15.5631 16.3906 14.3288 17.125C13.0475 17.875 11.6569 18.25 10.1569 18.25C8.65689 18.25 7.26626 17.875 5.98501 17.125C4.75064 16.3906 3.76626 15.4062 3.03189 14.1719C2.28189 12.8906 1.90689 11.5 1.90689 10C1.90689 8.5 2.28189 7.10938 3.03189 5.82812C3.76626 4.59375 4.75064 3.60938 5.98501 2.875C7.26626 2.125 8.65689 1.75 10.1569 1.75ZM7.32095 6.08594L6.24283 7.16406L9.07876 10L6.24283 12.8359L7.32095 13.9141L10.1569 11.0781L12.9928 13.9141L14.071 12.8359L11.235 10L14.071 7.16406L12.9928 6.08594L10.1569 8.92188L7.32095 6.08594Z"
        fill="#778CA2"
      />
    </svg>
  );
}

function BagIcon() {
  return (
    <svg
      width="20"
      height="17"
      viewBox="0 0 20 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 0.75C8.09375 0.75 7.74219 0.898438 7.44531 1.19531C7.14844 1.49219 7 1.84375 7 2.25V3H2.5C1.89062 3 1.35938 3.22656 0.90625 3.67969C0.46875 4.11719 0.25 4.64062 0.25 5.25V16.5H19.75V5.25C19.75 4.64062 19.5234 4.11719 19.0703 3.67969C18.6328 3.22656 18.1094 3 17.5 3H13V2.25C13 1.84375 12.8516 1.49219 12.5547 1.19531C12.2578 0.898438 11.9062 0.75 11.5 0.75H8.5ZM8.5 2.25H11.5V3H8.5V2.25ZM2.5 4.5H17.5C17.7188 4.5 17.8984 4.57031 18.0391 4.71094C18.1797 4.85156 18.25 5.03125 18.25 5.25V15H1.75V5.25C1.75 5.03125 1.82031 4.85156 1.96094 4.71094C2.10156 4.57031 2.28125 4.5 2.5 4.5ZM9.25 6.75V9H7V10.5H9.25V12.75H10.75V10.5H13V9H10.75V6.75H9.25Z"
        fill="#98A9BC"
      />
    </svg>
  );
}

function MultiFamilyIcon(props) {
  return (
    <svg
      {...props}
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 0.708984L7.5957 1.0957L0.283203 8.4082L1.0918 9.2168L1.8125 8.49609V15H6.875V9.375H9.125V15H14.1875V8.49609L14.9082 9.2168L15.7168 8.4082L8.4043 1.0957L8 0.708984ZM8 2.30859L13.0625 7.37109V13.875H10.25V8.25H5.75V13.875H2.9375V7.37109L8 2.30859Z"
        fill={props.withErrors ? "red" : "#98A9BC"}
      />
    </svg>
  );
}

function BackRoundIcon(props) {
  return (
    <svg
      {...props}
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.84048 3.43359C4.58788 1.6862 6.69335 0.8125 9.15689 0.8125C11.6204 0.8125 13.7259 1.6862 15.4733 3.43359C17.2207 5.18099 18.0944 7.28646 18.0944 9.75C18.0944 12.2135 17.2207 14.319 15.4733 16.0664C13.7259 17.8138 11.6204 18.6875 9.15689 18.6875C6.69335 18.6875 4.58788 17.8138 2.84048 16.0664C1.09309 14.319 0.219388 12.2135 0.219388 9.75C0.219388 7.28646 1.09309 5.18099 2.84048 3.43359ZM14.485 4.42188C13.0241 2.93229 11.248 2.1875 9.15689 2.1875C7.06574 2.1875 5.27538 2.93229 3.78579 4.42188C2.32486 5.88281 1.59439 7.65885 1.59439 9.75C1.59439 11.8411 2.32486 13.6315 3.78579 15.1211C5.27538 16.582 7.06574 17.3125 9.15689 17.3125C11.248 17.3125 13.0241 16.582 14.485 15.1211C15.9746 13.6315 16.7194 11.8411 16.7194 9.75C16.7194 7.65885 15.9746 5.88281 14.485 4.42188ZM10.36 5.10938L11.3913 6.14062L7.73892 9.75L11.3913 13.3594L10.36 14.3906L6.23501 10.2656L5.80533 9.75L6.23501 9.23438L10.36 5.10938Z"
        fill="#778CA2"
      />
    </svg>
  );
}

function PropertyGeneralInfoIcon() {
  return (
    <svg
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.95455 0.9375C5.04048 0.9375 4.19087 1.16602 3.40572 1.62305C2.644 2.08008 2.03462 2.68945 1.57759 3.45117C1.12056 4.23633 0.892046 5.08594 0.892046 6C0.892046 6.36328 0.962358 6.78516 1.10298 7.26562C1.22017 7.66406 1.40181 8.13867 1.64791 8.68945C2.04634 9.5918 2.56783 10.5996 3.21236 11.7129C3.68111 12.5332 4.20259 13.377 4.77681 14.2441C5.06978 14.6895 5.31001 15.0469 5.49751 15.3164L5.95455 15.9844L7.13228 14.2441C7.7065 13.377 8.22798 12.5332 8.69673 11.7129C9.34126 10.5996 9.86275 9.5918 10.2612 8.68945C10.5073 8.13867 10.6889 7.66406 10.8061 7.26562C10.9467 6.78516 11.017 6.36328 11.017 6C11.017 5.08594 10.7885 4.23633 10.3315 3.45117C9.87447 2.68945 9.26509 2.08008 8.50337 1.62305C7.71822 1.16602 6.86861 0.9375 5.95455 0.9375ZM5.95455 2.0625C6.66939 2.0625 7.32564 2.23828 7.9233 2.58984C8.53267 2.94141 9.01314 3.42188 9.3647 4.03125C9.71626 4.62891 9.89205 5.28516 9.89205 6C9.89205 6.22266 9.83345 6.53906 9.71626 6.94922C9.59908 7.34766 9.44087 7.77539 9.24166 8.23242C8.90181 9.00586 8.39205 9.97852 7.71236 11.1504C7.13814 12.1348 6.56392 13.0605 5.9897 13.9277L5.95455 13.9629L5.91939 13.9277C5.34517 13.0605 4.77095 12.1348 4.19673 11.1504C3.51705 9.97852 3.00728 9.00586 2.66744 8.23242C2.46822 7.77539 2.31001 7.34766 2.19283 6.94922C2.07564 6.53906 2.01705 6.22266 2.01705 6C2.01705 5.28516 2.19283 4.62891 2.54439 4.03125C2.89595 3.42188 3.37056 2.94141 3.96822 2.58984C4.57759 2.23828 5.2397 2.0625 5.95455 2.0625ZM5.95455 4.875C5.63814 4.875 5.36861 4.98633 5.14595 5.20898C4.93501 5.41992 4.82955 5.68359 4.82955 6C4.82955 6.31641 4.93501 6.58594 5.14595 6.80859C5.36861 7.01953 5.63814 7.125 5.95455 7.125C6.27095 7.125 6.53462 7.01953 6.74556 6.80859C6.96822 6.58594 7.07955 6.31641 7.07955 6C7.07955 5.68359 6.96822 5.41992 6.74556 5.20898C6.53462 4.98633 6.27095 4.875 5.95455 4.875Z"
        fill="#778CA2"
      />
    </svg>
  );
}

function PropertyFeaturesIcon() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 0V12H12V7.5H4.5V0H0ZM1 1H3.5V2H2V3H3.5V4H2V5H3.5V6H2V7H3.5V7.79688L1 10.2969V1ZM4.20312 8.5H5V10H6V8.5H7V10H8V8.5H9V10H10V8.5H11V11H1.70312L4.20312 8.5Z"
        fill="#778CA2"
      />
    </svg>
  );
}

function PropertyLocationInfoIcon() {
  return (
    <svg
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.34054 0C6.12179 0 4.98507 0.310547 3.93038 0.931641C2.91085 1.51758 2.10812 2.32031 1.52218 3.33984C0.901087 4.39453 0.59054 5.53125 0.59054 6.75C0.59054 7.96875 0.901087 9.10547 1.52218 10.1602C2.10812 11.1797 2.91085 11.9883 3.93038 12.5859C4.98507 13.1953 6.12179 13.5 7.34054 13.5C8.55929 13.5 9.69601 13.1953 10.7507 12.5859C11.7702 11.9883 12.5788 11.1797 13.1765 10.1602C13.7859 9.10547 14.0905 7.96875 14.0905 6.75C14.0905 5.53125 13.7859 4.39453 13.1765 3.33984C12.5788 2.32031 11.7702 1.51758 10.7507 0.931641C9.69601 0.310547 8.55929 0 7.34054 0ZM6.76046 1.16016C6.77218 1.16016 6.77804 1.16016 6.77804 1.16016V1.6875H7.90304V1.16016C8.78195 1.24219 9.58468 1.51758 10.3112 1.98633C11.0495 2.44336 11.6472 3.04102 12.1042 3.7793C12.573 4.50586 12.8484 5.30859 12.9304 6.1875H12.403V7.3125H12.9304C12.8484 8.19141 12.573 9 12.1042 9.73828C11.6472 10.4648 11.0495 11.0625 10.3112 11.5312C9.58468 11.9883 8.78195 12.2578 7.90304 12.3398V11.8125H6.77804V12.3398C5.89913 12.2578 5.09054 11.9883 4.35226 11.5312C3.6257 11.0625 3.02804 10.4648 2.55929 9.73828C2.10226 9 1.83273 8.19141 1.7507 7.3125H2.27804V6.1875H1.7507C1.83273 5.30859 2.10226 4.50586 2.55929 3.7793C3.02804 3.04102 3.6257 2.44336 4.35226 1.98633C5.07882 1.5293 5.88156 1.25391 6.76046 1.16016ZM10.9968 3.09375L6.30343 5.71289L3.68429 10.4062L8.37765 7.78711L10.9968 3.09375ZM7.34054 5.90625C7.57491 5.90625 7.77413 5.98828 7.9382 6.15234C8.10226 6.31641 8.18429 6.51562 8.18429 6.75C8.18429 6.98438 8.10226 7.18359 7.9382 7.34766C7.77413 7.51172 7.57491 7.59375 7.34054 7.59375C7.10616 7.59375 6.90695 7.51172 6.74288 7.34766C6.57882 7.18359 6.49679 6.98438 6.49679 6.75C6.49679 6.51562 6.57882 6.31641 6.74288 6.15234C6.90695 5.98828 7.10616 5.90625 7.34054 5.90625Z"
        fill="#778CA2"
      />
    </svg>
  );
}

function PropertyOtherCriteriaIcon() {
  return (
    <svg
      width="15"
      height="12"
      viewBox="0 0 15 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.12374 0.220703L2.27804 2.08398L1.55734 1.3457L0.748743 2.1543L2.27804 3.66602L4.93234 1.0293L4.12374 0.220703ZM6.21554 1.1875V2.3125H14.0905V1.1875H6.21554ZM6.21554 5.6875V6.8125H14.0905V5.6875H6.21554ZM6.21554 10.1875V11.3125H14.0905V10.1875H6.21554Z"
        fill="#778CA2"
      />
    </svg>
  );
}

function UsersIcon(props) {
  return (
    <svg
      {...props}
      width="18"
      height="11"
      viewBox="0 0 18 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.0625 0.1875C4.45312 0.1875 3.89062 0.339844 3.375 0.644531C2.85938 0.949219 2.44922 1.35937 2.14453 1.875C1.83984 2.39063 1.6875 2.95313 1.6875 3.5625C1.6875 4.11328 1.81055 4.62891 2.05664 5.10938C2.30273 5.57812 2.64258 5.9707 3.07617 6.28711C2.32617 6.66211 1.7168 7.21289 1.24805 7.93945C0.791016 8.6543 0.5625 9.44531 0.5625 10.3125H1.6875C1.6875 9.70312 1.83984 9.14062 2.14453 8.625C2.44922 8.10938 2.85938 7.69922 3.375 7.39453C3.89062 7.08984 4.45312 6.9375 5.0625 6.9375C5.67188 6.9375 6.23438 7.08984 6.75 7.39453C7.26562 7.69922 7.67578 8.10938 7.98047 8.625C8.28516 9.14062 8.4375 9.70312 8.4375 10.3125H9.5625C9.5625 9.70312 9.71484 9.14062 10.0195 8.625C10.3242 8.10938 10.7344 7.69922 11.25 7.39453C11.7656 7.08984 12.3281 6.9375 12.9375 6.9375C13.5469 6.9375 14.1094 7.08984 14.625 7.39453C15.1406 7.69922 15.5508 8.10938 15.8555 8.625C16.1602 9.14062 16.3125 9.70312 16.3125 10.3125H17.4375C17.4375 9.44531 17.2031 8.6543 16.7344 7.93945C16.2773 7.21289 15.6738 6.66211 14.9238 6.28711C15.3574 5.9707 15.6973 5.57812 15.9434 5.10938C16.1895 4.62891 16.3125 4.11328 16.3125 3.5625C16.3125 2.95313 16.1602 2.39063 15.8555 1.875C15.5508 1.35937 15.1406 0.949219 14.625 0.644531C14.1094 0.339844 13.5469 0.1875 12.9375 0.1875C12.3281 0.1875 11.7656 0.339844 11.25 0.644531C10.7344 0.949219 10.3242 1.35937 10.0195 1.875C9.71484 2.39063 9.5625 2.95313 9.5625 3.5625C9.5625 4.11328 9.68555 4.62891 9.93164 5.10938C10.1777 5.57812 10.5176 5.9707 10.9512 6.28711C10.0957 6.70898 9.44531 7.32422 9 8.13281C8.55469 7.32422 7.9043 6.70898 7.04883 6.28711C7.48242 5.9707 7.82227 5.57812 8.06836 5.10938C8.31445 4.62891 8.4375 4.11328 8.4375 3.5625C8.4375 2.95313 8.28516 2.39063 7.98047 1.875C7.67578 1.35937 7.26562 0.949219 6.75 0.644531C6.23438 0.339844 5.67188 0.1875 5.0625 0.1875ZM5.0625 1.3125C5.47266 1.3125 5.84766 1.41211 6.1875 1.61133C6.53906 1.81055 6.81445 2.08594 7.01367 2.4375C7.21289 2.77734 7.3125 3.15234 7.3125 3.5625C7.3125 3.97266 7.21289 4.35352 7.01367 4.70508C6.81445 5.04492 6.53906 5.31445 6.1875 5.51367C5.84766 5.71289 5.47266 5.8125 5.0625 5.8125C4.65234 5.8125 4.27148 5.71289 3.91992 5.51367C3.58008 5.31445 3.31055 5.04492 3.11133 4.70508C2.91211 4.35352 2.8125 3.97266 2.8125 3.5625C2.8125 3.15234 2.91211 2.77734 3.11133 2.4375C3.31055 2.08594 3.58008 1.81055 3.91992 1.61133C4.27148 1.41211 4.65234 1.3125 5.0625 1.3125ZM12.9375 1.3125C13.3477 1.3125 13.7227 1.41211 14.0625 1.61133C14.4141 1.81055 14.6895 2.08594 14.8887 2.4375C15.0879 2.77734 15.1875 3.15234 15.1875 3.5625C15.1875 3.97266 15.0879 4.35352 14.8887 4.70508C14.6895 5.04492 14.4141 5.31445 14.0625 5.51367C13.7227 5.71289 13.3477 5.8125 12.9375 5.8125C12.5273 5.8125 12.1465 5.71289 11.7949 5.51367C11.4551 5.31445 11.1855 5.04492 10.9863 4.70508C10.7871 4.35352 10.6875 3.97266 10.6875 3.5625C10.6875 3.15234 10.7871 2.77734 10.9863 2.4375C11.1855 2.08594 11.4551 1.81055 11.7949 1.61133C12.1465 1.41211 12.5273 1.3125 12.9375 1.3125Z"
        fill="#778CA2"
      />
    </svg>
  );
}

function UnlinkIcon(props) {
  return (
    <svg
      {...props}
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2344 0.5C9.77734 0.5 9.33203 0.587891 8.89844 0.763672C8.46484 0.939453 8.07812 1.19727 7.73828 1.53711L6.91211 2.36328C6.63086 2.64453 6.40234 2.96094 6.22656 3.3125C6.0625 3.66406 5.95703 4.02734 5.91016 4.40234L7.03516 4.54297C7.10547 3.99219 7.32812 3.5293 7.70312 3.1543L8.5293 2.32812C8.83398 2.02344 9.19141 1.81836 9.60156 1.71289C10.0234 1.5957 10.4395 1.5957 10.8496 1.71289C11.2598 1.81836 11.6172 2.02344 11.9219 2.32812C12.2266 2.63281 12.4316 2.99023 12.5371 3.40039C12.6543 3.81055 12.6543 4.22656 12.5371 4.64844C12.4316 5.05859 12.2266 5.41602 11.9219 5.7207L11.0957 6.54688H11.0781C10.7031 6.92188 10.2461 7.14453 9.70703 7.21484L9.84766 8.33984C10.2227 8.29297 10.5859 8.1875 10.9375 8.02344C11.2891 7.84766 11.6055 7.61914 11.8867 7.33789L12.7129 6.51172C13.1582 6.06641 13.457 5.53906 13.6094 4.92969C13.7734 4.32031 13.7734 3.7168 13.6094 3.11914C13.457 2.50977 13.1582 1.98242 12.7129 1.53711C12.373 1.19727 11.9863 0.939453 11.5527 0.763672C11.1309 0.587891 10.6914 0.5 10.2344 0.5ZM2.3418 1.7832L1.5332 2.5918L3.7832 4.8418L4.5918 4.0332L2.3418 1.7832ZM4.15234 6.16016C3.77734 6.20703 3.41406 6.31836 3.0625 6.49414C2.71094 6.6582 2.39453 6.88086 2.11328 7.16211L1.28711 7.98828C0.841797 8.43359 0.537109 8.96094 0.373047 9.57031C0.220703 10.168 0.220703 10.7715 0.373047 11.3809C0.537109 11.9902 0.841797 12.5176 1.28711 12.9629C1.73242 13.4082 2.25977 13.7129 2.86914 13.877C3.47852 14.0293 4.08203 14.0293 4.67969 13.877C5.28906 13.7129 5.81641 13.4082 6.26172 12.9629L7.08789 12.1367C7.36914 11.8555 7.5918 11.5391 7.75586 11.1875C7.93164 10.8359 8.04297 10.4727 8.08984 10.0977L6.96484 9.95703C6.89453 10.5078 6.67188 10.9707 6.29688 11.3457L5.4707 12.1719C5.16602 12.4766 4.80273 12.6875 4.38086 12.8047C3.9707 12.9102 3.56055 12.9102 3.15039 12.8047C2.74023 12.6875 2.38281 12.4766 2.07812 12.1719C1.77344 11.8672 1.5625 11.5098 1.44531 11.0996C1.33984 10.6777 1.33984 10.2617 1.44531 9.85156C1.5625 9.44141 1.77344 9.08398 2.07812 8.7793L2.9043 7.95312H2.92188C3.29688 7.57812 3.75391 7.35547 4.29297 7.28516L4.15234 6.16016ZM10.2168 9.6582L9.4082 10.4668L11.6582 12.7168L12.4668 11.9082L10.2168 9.6582Z"
        fill="#778CA2"
      />
    </svg>
  );
}

function FinancialIcon(props) {
  return (
    <svg
      {...props}
      width="16"
      height="10"
      viewBox="0 0 16 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.125 0.1875V9.75H15.875V0.1875H0.125ZM2.375 1.3125H13.625C13.625 1.62891 13.7305 1.89844 13.9414 2.12109C14.1641 2.33203 14.4336 2.4375 14.75 2.4375V7.5C14.4336 7.5 14.1641 7.61133 13.9414 7.83398C13.7305 8.04492 13.625 8.30859 13.625 8.625H2.375C2.375 8.30859 2.26367 8.04492 2.04102 7.83398C1.83008 7.61133 1.56641 7.5 1.25 7.5V2.4375C1.56641 2.4375 1.83008 2.33203 2.04102 2.12109C2.26367 1.89844 2.375 1.62891 2.375 1.3125ZM8 2.4375C7.58984 2.4375 7.20898 2.55469 6.85742 2.78906C6.51758 3.01172 6.24805 3.31641 6.04883 3.70312C5.84961 4.08984 5.75 4.51172 5.75 4.96875C5.75 5.42578 5.84961 5.84766 6.04883 6.23438C6.24805 6.62109 6.51758 6.93164 6.85742 7.16602C7.20898 7.38867 7.58984 7.5 8 7.5C8.41016 7.5 8.78516 7.38867 9.125 7.16602C9.47656 6.93164 9.75195 6.62109 9.95117 6.23438C10.1504 5.84766 10.25 5.42578 10.25 4.96875C10.25 4.51172 10.1504 4.08984 9.95117 3.70312C9.75195 3.31641 9.47656 3.01172 9.125 2.78906C8.78516 2.55469 8.41016 2.4375 8 2.4375ZM8 3.5625C8.30469 3.5625 8.56836 3.70312 8.79102 3.98438C9.01367 4.25391 9.125 4.58203 9.125 4.96875C9.125 5.35547 9.01367 5.68945 8.79102 5.9707C8.56836 6.24023 8.30469 6.375 8 6.375C7.69531 6.375 7.43164 6.24023 7.20898 5.9707C6.98633 5.68945 6.875 5.35547 6.875 4.96875C6.875 4.58203 6.98633 4.25391 7.20898 3.98438C7.43164 3.70312 7.69531 3.5625 8 3.5625ZM3.78125 4.125C3.54688 4.125 3.34766 4.20703 3.18359 4.37109C3.01953 4.53516 2.9375 4.73438 2.9375 4.96875C2.9375 5.20312 3.01953 5.40234 3.18359 5.56641C3.34766 5.73047 3.54688 5.8125 3.78125 5.8125C4.01562 5.8125 4.21484 5.73047 4.37891 5.56641C4.54297 5.40234 4.625 5.20312 4.625 4.96875C4.625 4.73438 4.54297 4.53516 4.37891 4.37109C4.21484 4.20703 4.01562 4.125 3.78125 4.125ZM12.2188 4.125C11.9844 4.125 11.7852 4.20703 11.6211 4.37109C11.457 4.53516 11.375 4.73438 11.375 4.96875C11.375 5.20312 11.457 5.40234 11.6211 5.56641C11.7852 5.73047 11.9844 5.8125 12.2188 5.8125C12.4531 5.8125 12.6523 5.73047 12.8164 5.56641C12.9805 5.40234 13.0625 5.20312 13.0625 4.96875C13.0625 4.73438 12.9805 4.53516 12.8164 4.37109C12.6523 4.20703 12.4531 4.125 12.2188 4.125Z"
        fill="#778CA2"
      />
    </svg>
  );
}

function LeaseIcon(props) {
  return (
    <svg
      {...props}
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 0.9375C6.64844 0.9375 6.31445 1.04883 5.99805 1.27148L5.06641 1.92188L3.97656 2.0625L3.95898 2.08008C3.5957 2.16211 3.28516 2.33203 3.02734 2.58984C2.76953 2.84766 2.59961 3.1582 2.51758 3.52148L2.5 3.53906L2.35938 4.64648L1.69141 5.50781V5.52539C1.49219 5.8418 1.39258 6.1875 1.39258 6.5625C1.39258 6.9375 1.49805 7.27148 1.70898 7.56445L2.37695 8.49609L2.55273 9.46289L0.742188 12.2227L0.162109 13.084H2.85156L3.50195 14.5957L3.90625 15.5625L6.26172 12.0117C6.50781 12.1172 6.75977 12.1699 7.01758 12.1699C7.27539 12.1699 7.51562 12.1172 7.73828 12.0117L10.0938 15.5625L10.498 14.5957L11.1484 13.084H13.8379L13.2578 12.2227L11.5 9.55078L11.6406 8.49609L12.3086 7.54688V7.5293C12.5078 7.21289 12.6074 6.87305 12.6074 6.50977C12.6074 6.13477 12.502 5.80078 12.291 5.50781L11.6406 4.57617L11.4297 3.52148H11.4473L11.4297 3.48633C11.3828 3.11133 11.2246 2.79492 10.9551 2.53711C10.6855 2.26758 10.3691 2.10937 10.0059 2.0625L8.93359 1.92188L8.00195 1.27148C7.68555 1.04883 7.35156 0.9375 7 0.9375ZM7 2.08008C7.12891 2.08008 7.24609 2.11523 7.35156 2.18555L8.47656 2.99414L9.86523 3.1875C9.99414 3.19922 10.0996 3.24609 10.1816 3.32812C10.2637 3.41016 10.3105 3.51562 10.3223 3.64453V3.67969L10.5684 5.05078L10.6562 5.15625L11.377 6.1582C11.4473 6.25195 11.4824 6.375 11.4824 6.52734C11.4824 6.66797 11.4414 6.80273 11.3594 6.93164L10.5684 8.03906L10.375 9.42773C10.3633 9.52148 10.334 9.60352 10.2871 9.67383L10.252 9.69141V9.70898C10.1699 9.81445 10.0586 9.87305 9.91797 9.88477H9.88281L8.59961 10.1133L8.45898 10.1309L8.35352 10.2188L7.35156 10.9395C7.25781 11.0098 7.13477 11.0449 6.98242 11.0449C6.83008 11.0449 6.68945 11.0039 6.56055 10.9219L5.54102 10.1309L4.13477 9.9375C3.95898 9.91406 3.83008 9.83203 3.74805 9.69141C3.71289 9.62109 3.68945 9.55078 3.67773 9.48047V9.44531L3.44922 8.16211L3.43164 8.02148L3.34375 7.91602L2.62305 6.91406C2.55273 6.82031 2.51758 6.69727 2.51758 6.54492C2.51758 6.39258 2.55859 6.25195 2.64062 6.12305L3.43164 5.10352L3.60742 3.76758L3.625 3.75C3.66016 3.60938 3.72461 3.49219 3.81836 3.39844C3.92383 3.29297 4.04688 3.22266 4.1875 3.1875L4.20508 3.16992L5.52344 2.99414L6.64844 2.18555C6.75391 2.11523 6.87109 2.08008 7 2.08008ZM10.8848 10.6406L11.7461 11.959H10.3926L10.252 12.3105L9.86523 13.207L8.66992 11.3789L8.93359 11.1855L10.041 10.9922V11.0098L10.0762 10.9922C10.3691 10.957 10.6387 10.8398 10.8848 10.6406ZM3.11523 10.6582C3.37305 10.8926 3.66602 11.0273 3.99414 11.0625L5.08398 11.2031L5.33008 11.3965L4.13477 13.207L3.74805 12.3105L3.60742 11.959H2.25391L3.11523 10.6582Z"
        fill="#778CA2"
      />
    </svg>
  );
}

function DateIcon(props) {
  return (
    <svg
      {...props}
      width="36"
      height="36"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="16" fill="white" />
      <circle cx="16" cy="16" r="16" fill="#4D7CFE" fillOpacity="0.08" />
      <path
        d="M12.0625 9.5V10.0625H9.8125V22.4375H22.1875V10.0625H19.9375V9.5H18.8125V10.0625H13.1875V9.5H12.0625ZM10.9375 11.1875H12.0625V11.75H13.1875V11.1875H18.8125V11.75H19.9375V11.1875H21.0625V12.3125H10.9375V11.1875ZM10.9375 13.4375H21.0625V21.3125H10.9375V13.4375ZM14.3125 14.5625V15.6875H15.4375V14.5625H14.3125ZM16.5625 14.5625V15.6875H17.6875V14.5625H16.5625ZM18.8125 14.5625V15.6875H19.9375V14.5625H18.8125ZM12.0625 16.8125V17.9375H13.1875V16.8125H12.0625ZM14.3125 16.8125V17.9375H15.4375V16.8125H14.3125ZM16.5625 16.8125V17.9375H17.6875V16.8125H16.5625ZM18.8125 16.8125V17.9375H19.9375V16.8125H18.8125ZM12.0625 19.0625V20.1875H13.1875V19.0625H12.0625ZM14.3125 19.0625V20.1875H15.4375V19.0625H14.3125ZM16.5625 19.0625V20.1875H17.6875V19.0625H16.5625Z"
        fill="#4D7CFE"
      />
    </svg>
  );
}

function PriceIcon() {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="16" fill="white" />
      <circle cx="16" cy="16" r="16" fill="#4D7CFE" fillOpacity="0.08" />
      <path
        d="M15.209 9.5L15.0332 9.6582L8.8457 15.8457L8.45898 16.25L8.8457 16.6543L13.9082 21.7168L14.3125 22.1035L14.7168 21.7168L20.9043 15.5293L21.0625 15.3535V9.5H15.209ZM15.6836 10.625H19.9375V14.8789L14.3125 20.5039L10.0586 16.25L15.6836 10.625ZM21.625 11.1875V12.3125H22.1875V16.9004L16.8438 22.209L16.1406 21.5059L15.3496 22.2969L16.4395 23.4043L16.8438 23.791L23.1543 17.5508L23.3125 17.375V11.1875H21.625ZM18.25 11.75C18.0977 11.75 17.9629 11.8086 17.8457 11.9258C17.7402 12.0312 17.6875 12.1602 17.6875 12.3125C17.6875 12.4648 17.7402 12.5996 17.8457 12.7168C17.9629 12.8223 18.0977 12.875 18.25 12.875C18.4023 12.875 18.5312 12.8223 18.6367 12.7168C18.7539 12.5996 18.8125 12.4648 18.8125 12.3125C18.8125 12.1602 18.7539 12.0312 18.6367 11.9258C18.5312 11.8086 18.4023 11.75 18.25 11.75Z"
        fill="#4D7CFE"
      />
    </svg>
  );
}

function CapRateIcon() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="16" fill="white" />
      <circle cx="16" cy="16" r="16" fill="#4D7CFE" fillOpacity="0.08" />
      <path
        d="M12.3438 10.625C11.9922 10.625 11.6641 10.7129 11.3594 10.8887C11.0547 11.0645 10.8145 11.3047 10.6387 11.6094C10.4629 11.9141 10.375 12.2422 10.375 12.5938V14.2812C10.375 14.6328 10.4629 14.9609 10.6387 15.2656C10.8145 15.5703 11.0547 15.8105 11.3594 15.9863C11.6641 16.1621 11.9922 16.25 12.3438 16.25C12.6953 16.25 13.0234 16.1621 13.3281 15.9863C13.6328 15.8105 13.873 15.5703 14.0488 15.2656C14.2246 14.9609 14.3125 14.6328 14.3125 14.2812V12.5938C14.3125 12.2422 14.2246 11.9141 14.0488 11.6094C13.873 11.3047 13.6328 11.0645 13.3281 10.8887C13.0234 10.7129 12.6953 10.625 12.3438 10.625ZM18.6719 10.625L11.9219 21.875H13.3281L20.0781 10.625H18.6719ZM12.3438 11.75C12.5781 11.75 12.7773 11.832 12.9414 11.9961C13.1055 12.1602 13.1875 12.3594 13.1875 12.5938V14.2812C13.1875 14.5156 13.1055 14.7148 12.9414 14.8789C12.7773 15.043 12.5781 15.125 12.3438 15.125C12.1094 15.125 11.9102 15.043 11.7461 14.8789C11.582 14.7148 11.5 14.5156 11.5 14.2812V12.5938C11.5 12.3594 11.582 12.1602 11.7461 11.9961C11.9102 11.832 12.1094 11.75 12.3438 11.75ZM19.6562 16.25C19.3047 16.25 18.9766 16.3379 18.6719 16.5137C18.3672 16.6895 18.127 16.9297 17.9512 17.2344C17.7754 17.5391 17.6875 17.8672 17.6875 18.2188V19.9062C17.6875 20.2578 17.7754 20.5859 17.9512 20.8906C18.127 21.1953 18.3672 21.4355 18.6719 21.6113C18.9766 21.7871 19.3047 21.875 19.6562 21.875C20.0078 21.875 20.3359 21.7871 20.6406 21.6113C20.9453 21.4355 21.1855 21.1953 21.3613 20.8906C21.5371 20.5859 21.625 20.2578 21.625 19.9062V18.2188C21.625 17.8672 21.5371 17.5391 21.3613 17.2344C21.1855 16.9297 20.9453 16.6895 20.6406 16.5137C20.3359 16.3379 20.0078 16.25 19.6562 16.25ZM19.6562 17.375C19.8906 17.375 20.0898 17.457 20.2539 17.6211C20.418 17.7852 20.5 17.9844 20.5 18.2188V19.9062C20.5 20.1406 20.418 20.3398 20.2539 20.5039C20.0898 20.668 19.8906 20.75 19.6562 20.75C19.4219 20.75 19.2227 20.668 19.0586 20.5039C18.8945 20.3398 18.8125 20.1406 18.8125 19.9062V18.2188C18.8125 17.9844 18.8945 17.7852 19.0586 17.6211C19.2227 17.457 19.4219 17.375 19.6562 17.375Z"
        fill="#4D7CFE"
      />
    </svg>
  );
}

function RbaIcon() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="16" fill="white" />
      <circle cx="16" cy="16" r="16" fill="#4D7CFE" fillOpacity="0.08" />
      <path
        d="M9.25 9.5V23H22.75V17.9375H14.3125V9.5H9.25ZM10.375 10.625H13.1875V11.75H11.5V12.875H13.1875V14H11.5V15.125H13.1875V16.25H11.5V17.375H13.1875V18.2715L10.375 21.084V10.625ZM13.9785 19.0625H14.875V20.75H16V19.0625H17.125V20.75H18.25V19.0625H19.375V20.75H20.5V19.0625H21.625V21.875H11.166L13.9785 19.0625Z"
        fill="#4D7CFE"
      />
    </svg>
  );
}

function SellerIcon(props) {
  return (
    <svg
      {...props}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 0.0625L6.82422 0.220703L0.0214844 7.09375L0.408203 7.49805L5.75195 12.8418L6.15625 13.2285L13.0293 6.42578L13.1875 6.25V0.0625H7ZM7.47461 1.1875H12.0625V5.77539L6.15625 11.6465L1.60352 7.09375L7.47461 1.1875ZM10.375 2.3125C10.2227 2.3125 10.0879 2.37109 9.9707 2.48828C9.86523 2.59375 9.8125 2.72266 9.8125 2.875C9.8125 3.02734 9.86523 3.16211 9.9707 3.2793C10.0879 3.38477 10.2227 3.4375 10.375 3.4375C10.5273 3.4375 10.6562 3.38477 10.7617 3.2793C10.8789 3.16211 10.9375 3.02734 10.9375 2.875C10.9375 2.72266 10.8789 2.59375 10.7617 2.48828C10.6562 2.37109 10.5273 2.3125 10.375 2.3125Z"
        fill="#98A9BC"
      />
    </svg>
  );
}

function BuyerIcon(props) {
  return (
    <svg
      {...props}
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 0.990234L2.99023 6H0.125V9.375H0.828125L2.51562 15H13.4844L15.1719 9.375H15.875V6H13.0098L8 0.990234ZM8 2.58984L11.4102 6H4.58984L8 2.58984ZM1.25 7.125H14.75V8.25H14.3281L12.6406 13.875H3.35938L1.67188 8.25H1.25V7.125ZM5.1875 8.8125V12.75H6.3125V8.8125H5.1875ZM7.4375 8.8125V12.75H8.5625V8.8125H7.4375ZM9.6875 8.8125V12.75H10.8125V8.8125H9.6875Z"
        fill="#98A9BC"
      />
    </svg>
  );
}

function FiltersIcon(props) {
  return (
    <svg
      {...props}
      width="13"
      height="14"
      viewBox="0 0 13 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.127885 0.5V1.81836L4.62788 7.44336V14L8.00288 11.4688V7.44336L12.5029 1.81836V0.5H0.127885ZM1.41109 1.625H11.2197L7.17671 6.6875H5.45406L1.41109 1.625ZM5.75288 7.8125H6.87788V10.9062L5.75288 11.75V7.8125Z"
        fill="#778CA2"
      />
    </svg>
  );
}

function LockIcon(props) {
  return (
    <svg
      {...props}
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 0.9375C5.29688 0.9375 4.64062 1.11914 4.03125 1.48242C3.43359 1.83398 2.95312 2.31445 2.58984 2.92383C2.23828 3.52148 2.0625 4.17188 2.0625 4.875V6.5625H0.375V15.5625H11.625V6.5625H9.9375V4.875C9.9375 4.17188 9.75586 3.52148 9.39258 2.92383C9.04102 2.31445 8.56055 1.83398 7.95117 1.48242C7.35352 1.11914 6.70312 0.9375 6 0.9375ZM6 2.0625C6.50391 2.0625 6.97266 2.19141 7.40625 2.44922C7.83984 2.69531 8.17969 3.03516 8.42578 3.46875C8.68359 3.90234 8.8125 4.37109 8.8125 4.875V6.5625H3.1875V4.875C3.1875 4.37109 3.31055 3.90234 3.55664 3.46875C3.81445 3.03516 4.16016 2.69531 4.59375 2.44922C5.02734 2.19141 5.49609 2.0625 6 2.0625ZM1.5 7.6875H10.5V14.4375H1.5V7.6875Z"
        fill="#4D7CFE"
      />
    </svg>
  );
}

function UnlockIcon(props) {
  return (
    <svg
      {...props}
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 0.9375C5.16797 0.9375 4.40625 1.18359 3.71484 1.67578C3.05859 2.15625 2.57812 2.77734 2.27344 3.53906L3.31055 3.96094C3.5332 3.39844 3.88477 2.94141 4.36523 2.58984C4.85742 2.23828 5.40234 2.0625 6 2.0625C6.50391 2.0625 6.97266 2.19141 7.40625 2.44922C7.83984 2.69531 8.17969 3.03516 8.42578 3.46875C8.68359 3.90234 8.8125 4.37109 8.8125 4.875V6.5625H0.375V15.5625H11.625V6.5625H9.9375V4.875C9.9375 4.17188 9.75586 3.52148 9.39258 2.92383C9.04102 2.31445 8.56055 1.83398 7.95117 1.48242C7.35352 1.11914 6.70312 0.9375 6 0.9375ZM1.5 7.6875H10.5V14.4375H1.5V7.6875Z"
        fill="#778CA2"
      />
    </svg>
  );
}

function MatchesIcon(props) {
  return (
    <svg
      {...props}
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5625 0.9375C8.15234 0.9375 7.77148 1.03711 7.41992 1.23633C7.08008 1.43555 6.81055 1.71094 6.61133 2.0625C6.41211 2.40234 6.3125 2.77734 6.3125 3.1875H2.9375V6C2.52734 6 2.14648 6.09961 1.79492 6.29883C1.45508 6.49805 1.18555 6.77344 0.986328 7.125C0.787109 7.46484 0.6875 7.83984 0.6875 8.25C0.6875 8.66016 0.787109 9.04102 0.986328 9.39258C1.18555 9.73242 1.45508 10.002 1.79492 10.2012C2.14648 10.4004 2.52734 10.5 2.9375 10.5V13.3125H6.3125C6.3125 13.7227 6.41211 14.1035 6.61133 14.4551C6.81055 14.7949 7.08008 15.0645 7.41992 15.2637C7.77148 15.4629 8.15234 15.5625 8.5625 15.5625C8.97266 15.5625 9.34766 15.4629 9.6875 15.2637C10.0391 15.0645 10.3145 14.7949 10.5137 14.4551C10.7129 14.1035 10.8125 13.7227 10.8125 13.3125H14.1875V9.375H13.0625C12.7227 9.375 12.4473 9.27539 12.2363 9.07617C12.0371 8.86523 11.9375 8.58984 11.9375 8.25C11.9375 7.91016 12.0371 7.64062 12.2363 7.44141C12.4473 7.23047 12.7227 7.125 13.0625 7.125H14.1875V3.1875H10.8125C10.8125 2.77734 10.7129 2.40234 10.5137 2.0625C10.3145 1.71094 10.0391 1.43555 9.6875 1.23633C9.34766 1.03711 8.97266 0.9375 8.5625 0.9375ZM8.5625 2.0625C8.90234 2.0625 9.17188 2.16797 9.37109 2.37891C9.58203 2.57813 9.6875 2.84766 9.6875 3.1875V4.3125H13.0625V6C12.6523 6 12.2715 6.09961 11.9199 6.29883C11.5801 6.49805 11.3105 6.77344 11.1113 7.125C10.9121 7.46484 10.8125 7.83984 10.8125 8.25C10.8125 8.66016 10.9121 9.04102 11.1113 9.39258C11.3105 9.73242 11.5801 10.002 11.9199 10.2012C12.2715 10.4004 12.6523 10.5 13.0625 10.5V12.1875H9.6875V13.3125C9.6875 13.6523 9.58203 13.9277 9.37109 14.1387C9.17188 14.3379 8.90234 14.4375 8.5625 14.4375C8.22266 14.4375 7.94727 14.3379 7.73633 14.1387C7.53711 13.9277 7.4375 13.6523 7.4375 13.3125V12.1875H4.0625V9.375H2.9375C2.59766 9.375 2.32227 9.27539 2.11133 9.07617C1.91211 8.86523 1.8125 8.58984 1.8125 8.25C1.8125 7.91016 1.91211 7.64062 2.11133 7.44141C2.32227 7.23047 2.59766 7.125 2.9375 7.125H4.0625V4.3125H7.4375V3.1875C7.4375 2.84766 7.53711 2.57813 7.73633 2.37891C7.94727 2.16797 8.22266 2.0625 8.5625 2.0625Z"
        fill="#778CA2"
      />
    </svg>
  );
}

function ShowPasswordIcon(props) {
  return (
    <svg
      {...props}
      width="18"
      height="10"
      viewBox="0 0 18 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.32812 1.20703C7.24219 0.902344 8.13281 0.75 9 0.75C9.86719 0.75 10.7461 0.890625 11.6367 1.17188C12.5273 1.45312 13.3008 1.80469 13.957 2.22656C14.6133 2.625 15.1992 3.02344 15.7148 3.42188C16.2305 3.82031 16.6289 4.16016 16.9102 4.44141L17.2969 4.89844L17.6484 5.25L17.2969 5.60156C17.2031 5.71875 17.0742 5.85938 16.9102 6.02344C16.7461 6.1875 16.3945 6.49219 15.8555 6.9375C15.3164 7.38281 14.7656 7.78125 14.2031 8.13281C13.6406 8.48438 12.9375 8.82422 12.0938 9.15234C11.2734 9.45703 10.4531 9.64453 9.63281 9.71484C9.44531 9.73828 9.23438 9.75 9 9.75C8.76562 9.75 8.55469 9.73828 8.36719 9.71484C7.54688 9.64453 6.72656 9.45703 5.90625 9.15234C5.08594 8.84766 4.37109 8.50781 3.76172 8.13281C3.17578 7.73438 2.63672 7.34766 2.14453 6.97266C1.67578 6.59766 1.3125 6.28125 1.05469 6.02344L0.703125 5.60156L0.351562 5.25L0.703125 4.89844C0.796875 4.78125 0.9375 4.62891 1.125 4.44141C1.3125 4.25391 1.6875 3.92578 2.25 3.45703C2.83594 2.96484 3.43359 2.54297 4.04297 2.19141C4.67578 1.81641 5.4375 1.48828 6.32812 1.20703ZM9 1.875C7.89844 1.875 6.76172 2.14453 5.58984 2.68359H5.625C5.25 3.29297 5.0625 3.96094 5.0625 4.6875C5.0625 5.69531 5.39062 6.57422 6.04688 7.32422C6.72656 8.07422 7.57031 8.50781 8.57812 8.625C8.76562 8.625 8.90625 8.625 9 8.625C9.07031 8.625 9.21094 8.625 9.42188 8.625C10.4297 8.50781 11.2617 8.07422 11.918 7.32422C12.5977 6.57422 12.9375 5.69531 12.9375 4.6875C12.9375 3.96094 12.75 3.28125 12.375 2.64844C11.2266 2.13281 10.1016 1.875 9 1.875ZM7.80469 3.49219C8.13281 3.16406 8.53125 3 9 3C9.46875 3 9.86719 3.16406 10.1953 3.49219C10.5234 3.82031 10.6875 4.21875 10.6875 4.6875C10.6875 5.15625 10.5234 5.55469 10.1953 5.88281C9.86719 6.21094 9.46875 6.375 9 6.375C8.53125 6.375 8.13281 6.21094 7.80469 5.88281C7.47656 5.55469 7.3125 5.15625 7.3125 4.6875C7.3125 4.21875 7.47656 3.82031 7.80469 3.49219ZM4.07812 3.52734C3.30469 4.04297 2.60156 4.61719 1.96875 5.25C2.8125 6.09375 3.72656 6.79688 4.71094 7.35938C4.19531 6.5625 3.9375 5.67188 3.9375 4.6875C3.9375 4.3125 3.98438 3.92578 4.07812 3.52734ZM13.9219 3.52734C14.0156 3.92578 14.0625 4.3125 14.0625 4.6875C14.0625 5.67188 13.8047 6.5625 13.2891 7.35938C14.2734 6.79688 15.1875 6.09375 16.0312 5.25C15.3984 4.61719 14.6953 4.04297 13.9219 3.52734Z"
        fill="#778CA2"
      />
    </svg>
  );
}

function LinkedinIcon(props) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.6875 3.37499C1.22916 3.37499 0.833331 3.20833 0.499999 2.87499C0.166666 2.54166 0 2.14583 0 1.6875C0 1.22916 0.166666 0.833331 0.499999 0.499999C0.833331 0.166666 1.22916 0 1.6875 0C2.14583 0 2.54166 0.166666 2.87499 0.499999C3.20833 0.833331 3.37499 1.22916 3.37499 1.6875C3.37499 2.14583 3.20833 2.54166 2.87499 2.87499C2.54166 3.20833 2.14583 3.37499 1.6875 3.37499ZM3.12499 14H0.21875V4.65625H3.12499V14ZM11.0937 14H14V8.87499C14 7.43749 13.7916 6.375 13.375 5.6875C12.8333 4.83333 11.8854 4.40625 10.5312 4.40625C9.86456 4.40625 9.28122 4.57292 8.78123 4.90625C8.32289 5.17708 7.98956 5.52083 7.78123 5.9375H7.74998V4.65625H4.96873V14H7.84373V9.37499C7.84373 8.64582 7.94789 8.09374 8.15623 7.71874C8.42706 7.21874 8.89581 6.96874 9.56247 6.96874C10.2291 6.96874 10.6771 7.24999 10.9062 7.81249C11.0312 8.14582 11.0937 8.68749 11.0937 9.43749V14Z"
        fill="#778CA2"
      />
    </svg>
  );
}

function WebsiteIcon(props) {
  return (
    <svg
      {...props}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 0C4.91667 0 3.90625 0.276042 2.96875 0.828125C2.0625 1.34896 1.34896 2.0625 0.828125 2.96875C0.276042 3.90625 0 4.91667 0 6C0 7.08333 0.276042 8.09375 0.828125 9.03125C1.34896 9.9375 2.0625 10.6562 2.96875 11.1875C3.90625 11.7292 4.91667 12 6 12C7.08333 12 8.09375 11.7292 9.03125 11.1875C9.9375 10.6562 10.6562 9.9375 11.1875 9.03125C11.7292 8.09375 12 7.08333 12 6C12 4.91667 11.7292 3.90625 11.1875 2.96875C10.6562 2.0625 9.9375 1.34896 9.03125 0.828125C8.09375 0.276042 7.08333 0 6 0ZM6 1C6.95833 1 7.84896 1.26042 8.67188 1.78125L8.26562 1.82812L8.35938 2.82812L7.82812 2.59375L7.39062 2.96875L7.46875 4L8.54688 3.65625L9.89062 4.09375L9.54688 4.71875L8.73438 4.21875L7.85938 4.34375L7 4.98438L6.51562 6.48438L7.48438 7.28125L8.53125 7.10938C8.55208 7.10938 8.63021 7.26042 8.76562 7.5625L8.95312 8.01562L8.15625 10.5156C7.47917 10.8385 6.76042 11 6 11C5.91667 11 5.78646 10.9896 5.60938 10.9688H5.53125L4.98438 10.0156L5.51562 8.01562L3.5 6.5H1.64062L1.15625 5.51562L2.5 4.45312L4.5 3.5L4.20312 2.17188L5.0625 1.98438L5.46875 2.54688L6.96875 2.26562L6.70312 1.10938L5.59375 1.03125L5.73438 1.01562C5.84896 1.00521 5.9375 1 6 1ZM5.4375 1.03125L4.65625 1.35938L4.28125 1.29688C4.64583 1.16146 5.03125 1.07292 5.4375 1.03125ZM1.03125 6.39062L1.51562 6.95312V7.98438L2.45312 9.01562H3.03125L4.45312 10.7656C3.82812 10.5677 3.26562 10.2552 2.76562 9.82812C2.26562 9.39062 1.86458 8.88021 1.5625 8.29688C1.26042 7.70312 1.08333 7.06771 1.03125 6.39062Z"
        fill="#778CA2"
      />
    </svg>
  );
}

function ImportNotificationIcon(props) {
  return (
    <svg
      {...props}
      width="14"
      height="19"
      viewBox="0 0 14 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 0.8125C6.61328 0.8125 6.28385 0.948568 6.01172 1.2207C5.75391 1.47852 5.625 1.80078 5.625 2.1875L5.64648 2.35938C4.85872 2.5599 4.14974 2.91797 3.51953 3.43359C2.88932 3.94922 2.39518 4.57943 2.03711 5.32422C1.67904 6.05469 1.5 6.84245 1.5 7.6875V13.875C1.5 14.0755 1.43555 14.2402 1.30664 14.3691C1.17773 14.498 1.01302 14.5625 0.8125 14.5625H0.125V15.9375H5.06641C4.98047 16.181 4.9375 16.4102 4.9375 16.625C4.9375 17.1836 5.13802 17.6634 5.53906 18.0645C5.95443 18.4798 6.44141 18.6875 7 18.6875C7.55859 18.6875 8.03841 18.4798 8.43945 18.0645C8.85482 17.6634 9.0625 17.1836 9.0625 16.625C9.0625 16.4102 9.01953 16.181 8.93359 15.9375H13.875V14.5625H13.1875C12.987 14.5625 12.8223 14.498 12.6934 14.3691C12.5645 14.2402 12.5 14.0755 12.5 13.875V7.88086C12.5 7.03581 12.321 6.23372 11.9629 5.47461C11.6191 4.70117 11.1322 4.04232 10.502 3.49805C9.87174 2.95378 9.1556 2.57422 8.35352 2.35938L8.375 2.1875C8.375 1.80078 8.23893 1.47852 7.9668 1.2207C7.70898 0.948568 7.38672 0.8125 7 0.8125ZM6.69922 3.5625C6.74219 3.5625 6.80664 3.5625 6.89258 3.5625H7.12891C7.85938 3.59115 8.53255 3.80599 9.14844 4.20703C9.76432 4.59375 10.2441 5.11654 10.5879 5.77539C10.946 6.43424 11.125 7.13607 11.125 7.88086V13.875C11.125 14.0898 11.168 14.319 11.2539 14.5625H2.74609C2.83203 14.319 2.875 14.0898 2.875 13.875V7.6875C2.875 6.97135 3.03971 6.3125 3.36914 5.71094C3.71289 5.09505 4.17839 4.60091 4.76562 4.22852C5.35286 3.8418 5.9974 3.61979 6.69922 3.5625ZM7 15.9375C7.20052 15.9375 7.36523 16.002 7.49414 16.1309C7.62305 16.2598 7.6875 16.4245 7.6875 16.625C7.6875 16.8112 7.62305 16.9759 7.49414 17.1191C7.36523 17.248 7.20052 17.3125 7 17.3125C6.8138 17.3125 6.64909 17.248 6.50586 17.1191C6.37695 16.9759 6.3125 16.8112 6.3125 16.625C6.3125 16.4245 6.37695 16.2598 6.50586 16.1309C6.64909 16.002 6.8138 15.9375 7 15.9375Z"
        fill="#778CA2"
      />
    </svg>
  );
}

function ActivityIcon(props) {
  return (
    <svg
      {...props}
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 0.5C7.59635 0.5 6.27865 0.836589 5.04688 1.50977C3.85807 2.1543 2.88411 3.04232 2.125 4.17383V1.875H0.75V6.6875H5.5625V5.3125H3.07031C3.67188 4.26693 4.48828 3.4362 5.51953 2.82031C6.59375 2.1901 7.75391 1.875 9 1.875C10.2461 1.875 11.4062 2.1901 12.4805 2.82031C13.5117 3.42188 14.3281 4.23828 14.9297 5.26953C15.5599 6.34375 15.875 7.50391 15.875 8.75C15.875 9.99609 15.5599 11.1562 14.9297 12.2305C14.3281 13.2617 13.5117 14.0781 12.4805 14.6797C11.4062 15.3099 10.2461 15.625 9 15.625C7.75391 15.625 6.59375 15.3099 5.51953 14.6797C4.48828 14.0781 3.67188 13.2617 3.07031 12.2305C2.4401 11.1562 2.125 9.99609 2.125 8.75H0.75C0.75 10.2396 1.12956 11.6289 1.88867 12.918C2.60482 14.1641 3.58594 15.1523 4.83203 15.8828C6.12109 16.6276 7.51042 17 9 17C10.4896 17 11.8789 16.6276 13.168 15.8828C14.4141 15.1523 15.4023 14.1641 16.1328 12.918C16.8776 11.6289 17.25 10.2396 17.25 8.75C17.25 7.26042 16.8776 5.87109 16.1328 4.58203C15.4023 3.33594 14.4141 2.35482 13.168 1.63867C11.8789 0.879557 10.4896 0.5 9 0.5ZM8.3125 3.25V9.4375H13.125V8.0625H9.6875V3.25H8.3125Z"
        fill="#778CA2"
      />
    </svg>
  );
}

function CalendarIcon(props) {
  return (
    <svg
      {...props}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.0625 0.250977V0.813477H0.8125V13.1885H13.1875V0.813477H10.9375V0.250977H9.8125V0.813477H4.1875V0.250977H3.0625ZM1.9375 1.93848H3.0625V2.50098H4.1875V1.93848H9.8125V2.50098H10.9375V1.93848H12.0625V3.06348H1.9375V1.93848ZM1.9375 4.18848H12.0625V12.0635H1.9375V4.18848ZM5.3125 5.31348V6.43848H6.4375V5.31348H5.3125ZM7.5625 5.31348V6.43848H8.6875V5.31348H7.5625ZM9.8125 5.31348V6.43848H10.9375V5.31348H9.8125ZM3.0625 7.56348V8.68848H4.1875V7.56348H3.0625ZM5.3125 7.56348V8.68848H6.4375V7.56348H5.3125ZM7.5625 7.56348V8.68848H8.6875V7.56348H7.5625ZM9.8125 7.56348V8.68848H10.9375V7.56348H9.8125ZM3.0625 9.81348V10.9385H4.1875V9.81348H3.0625ZM5.3125 9.81348V10.9385H6.4375V9.81348H5.3125ZM7.5625 9.81348V10.9385H8.6875V9.81348H7.5625Z"
        fill="#778CA2"
      />
    </svg>
  );
}

function PersonIcon(props) {
  return (
    <svg
      {...props}
      width="36"
      height="36"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="16" fill="white" />
      <circle cx="16" cy="16" r="16" fill="#4D7CFE" fillOpacity="0.08" />
    </svg>
  );
}

export {
  ActivityIcon,
  AddContactIcon,
  BackRoundIcon,
  BagIcon,
  BuyerIcon,
  CalendarIcon,
  CapRateIcon,
  CloseIcon,
  CloseRoundIcon,
  DateIcon,
  DeleteIcon,
  EditIcon,
  FiltersIcon,
  FinancialIcon,
  ImportNotificationIcon,
  LeaseIcon,
  LinkedinIcon,
  LockIcon,
  MatchesIcon,
  MoreIcon,
  MultiFamilyIcon,
  NextIcon,
  PersonIcon,
  PrevIcon,
  PriceIcon,
  PropertyFeaturesIcon,
  PropertyGeneralInfoIcon,
  PropertyLocationInfoIcon,
  PropertyOtherCriteriaIcon,
  RbaIcon,
  RingIcon,
  SelectIcon,
  SellerIcon,
  ShowPasswordIcon,
  UnlinkIcon,
  UnlockIcon,
  UsersIcon,
  WebsiteIcon
};
